import React, { useEffect, useState } from "react";
import companyIcon from "../images/svg/companyIcon.svg";
import PowerBIIcon from "../images/svg/powerBIIcon.svg";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

const Sidebar = ({ page, access }) => {
  const navigate = useNavigate();
  const [privateSidebar, setPrivateSidebar] = useState("");

  const container = {
    width: "229px",
    position: "fixed",
    top: "0",
    zIndex: "2",
    height: "100vh",
    background: "white",
    border: "1px solid #D7D7D7",
    borderTopRightRadius: 17,
    borderBottomRightRadius: 17,
  };
  const containerImage = {
    display: "flex",
    justifyContent: "center",
    marginTop: "2.625rem",
  };
  const containerItem = {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    width: "205px",
    borderRadius: "8px",
    paddingTop: "2px",
    paddingBottom: "3px",
    height: "39px",
    background: "var(--color-primary)",
    marginBottom: "21px",
    cursor: "pointer",
  };
  const containerItemNotChecked = {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    width: "205px",
    borderRadius: "8px",
    paddingTop: "2px",
    paddingBottom: "3px",
    height: "39px",
    background: "white",
    marginBottom: "21px",
    cursor: "pointer",
  };
  const image = {
    position: "relative",
    top: "1px",
    marginLeft: "11px",
  };

  const verifyPermissions = async () => { };

  const redirectToDashboardPage = () => {
    navigate("/dashboard");
  };

  const redirectToAccessPage = () => {
    navigate("/access");
  };

  const redirectToLoginPage = () => {
    navigate("/");
  };

  useEffect(() => {
    verifyPermissions();
  }, []);

  return (
    <div style={{ ...container }}>
      <div style={containerImage}>
        <img src={companyIcon} style={{ width: "83%" }} alt="" />
      </div>

      <div
        style={{
          paddingLeft: "12px",
          paddingRight: "12px",
          marginTop: "52px",
          height: "100%",
        }}
      >

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            gap: "300px",
          }}
        >
          <div>

            <div
              onClick={() => redirectToDashboardPage()}
              style={
                page == "Dashboard" ? containerItem : containerItemNotChecked
              }
            >
              <div style={image}>
                {page == "Dashboard" ? (
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#a)" fill="#fff"><path d="M19.493 12.5h-4.91a2.083 2.083 0 0 1-2.083-2.083V5.494a3.125 3.125 0 0 0-1.215-2.483 2.99 2.99 0 0 0-2.584-.556 11.426 11.426 0 0 0 .576 22.306 11.459 11.459 0 0 0 13.265-8.452 2.996 2.996 0 0 0-.556-2.588 3.183 3.183 0 0 0-2.493-1.221Zm1.029 3.3A9.342 9.342 0 1 1 9.21 4.48a.907.907 0 0 1 .796.178 1.058 1.058 0 0 1 .417.84v4.919a4.167 4.167 0 0 0 4.167 4.166h4.908a1.083 1.083 0 0 1 .85.417.92.92 0 0 1 .174.8Z" /><path d="M24.636 7.756A10.493 10.493 0 0 0 17.273.387a2.187 2.187 0 0 0-1.37.078 2.084 2.084 0 0 0-1.3 1.93v4.897a3.125 3.125 0 0 0 3.125 3.125h4.916a2.09 2.09 0 0 0 1.992-2.66Zm-2.602.577h-4.31a1.042 1.042 0 0 1-1.042-1.041l-.008-4.889a.05.05 0 0 1 .026-.01h.027a8.409 8.409 0 0 1 5.913 5.94h-.606Z" /></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h25v25H0z" /></clipPath></defs></svg>
                ) : (
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#a)" fill="#787486"><path d="M19.493 12.5h-4.91a2.083 2.083 0 0 1-2.083-2.083V5.494a3.125 3.125 0 0 0-1.215-2.483 2.99 2.99 0 0 0-2.584-.556 11.426 11.426 0 0 0 .576 22.306 11.459 11.459 0 0 0 13.265-8.452 2.996 2.996 0 0 0-.556-2.588 3.183 3.183 0 0 0-2.493-1.221Zm1.029 3.3A9.342 9.342 0 1 1 9.21 4.48a.907.907 0 0 1 .796.178 1.058 1.058 0 0 1 .417.84v4.919a4.167 4.167 0 0 0 4.167 4.166h4.908a1.083 1.083 0 0 1 .85.417.92.92 0 0 1 .174.8Z" /><path d="M24.636 7.756A10.493 10.493 0 0 0 17.273.387a2.187 2.187 0 0 0-1.37.078 2.084 2.084 0 0 0-1.3 1.93v4.897a3.125 3.125 0 0 0 3.125 3.125h4.916a2.09 2.09 0 0 0 1.992-2.66Zm-2.602.577h-4.31a1.042 1.042 0 0 1-1.042-1.041l-.008-4.889a.05.05 0 0 1 .026-.01h.027a8.409 8.409 0 0 1 5.913 5.94h-.606Z" /></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h25v25H0z" /></clipPath></defs></svg>
                )}
              </div>

              {page == "Dashboard" ? (
                <p
                  style={{ transform: "translateY(2px)" }}
                  className="textCheckedSidebar"
                >
                  Power BI
                </p>
              ) : (
                <p
                  style={{ transform: "translateY(2px)" }}
                  className="textNotCheckedSidebar"
                >
                  Power BI
                </p>
              )}
            </div>

            <div
              onClick={() => redirectToAccessPage()}
              style={
                page == "Access" ? containerItem : containerItemNotChecked
              }
            >
              <div style={image}>
                {page == "Access" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                  >
                    <path
                      d="M11.5 15.3333C10.7418 15.3333 10.0007 15.1085 9.37031 14.6873C8.73993 14.2661 8.2486 13.6674 7.95846 12.967C7.66832 12.2665 7.59241 11.4957 7.74032 10.7522C7.88823 10.0086 8.25332 9.32553 8.78942 8.78942C9.32552 8.25332 10.0086 7.88823 10.7522 7.74032C11.4957 7.59241 12.2665 7.66833 12.967 7.95846C13.6674 8.2486 14.2661 8.73993 14.6873 9.37032C15.1085 10.0007 15.3333 10.7418 15.3333 11.5C15.3333 12.5167 14.9295 13.4917 14.2106 14.2106C13.4917 14.9295 12.5167 15.3333 11.5 15.3333ZM11.5 9.58333C11.1209 9.58333 10.7504 9.69575 10.4352 9.90635C10.12 10.117 9.8743 10.4163 9.72923 10.7665C9.58416 11.1167 9.54621 11.5021 9.62016 11.8739C9.69412 12.2457 9.87666 12.5872 10.1447 12.8553C10.4128 13.1233 10.7543 13.3059 11.1261 13.3798C11.4979 13.4538 11.8833 13.4158 12.2335 13.2708C12.5837 13.1257 12.883 12.88 13.0936 12.5648C13.3043 12.2496 13.4167 11.8791 13.4167 11.5C13.4167 10.9917 13.2147 10.5042 12.8553 10.1447C12.4958 9.78527 12.0083 9.58333 11.5 9.58333ZM17.25 22.0417C17.25 20.5167 16.6442 19.0541 15.5659 17.9758C14.4875 16.8975 13.025 16.2917 11.5 16.2917C9.975 16.2917 8.51247 16.8975 7.43414 17.9758C6.3558 19.0541 5.75 20.5167 5.75 22.0417C5.75 22.2958 5.85097 22.5396 6.03069 22.7193C6.21041 22.899 6.45417 23 6.70833 23C6.9625 23 7.20625 22.899 7.38598 22.7193C7.5657 22.5396 7.66667 22.2958 7.66667 22.0417C7.66667 21.025 8.07053 20.05 8.78942 19.3311C9.50831 18.6122 10.4833 18.2083 11.5 18.2083C12.5167 18.2083 13.4917 18.6122 14.2106 19.3311C14.9295 20.05 15.3333 21.025 15.3333 22.0417C15.3333 22.2958 15.4343 22.5396 15.614 22.7193C15.7937 22.899 16.0375 23 16.2917 23C16.5458 23 16.7896 22.899 16.9693 22.7193C17.149 22.5396 17.25 22.2958 17.25 22.0417ZM17.25 7.66667C16.4918 7.66667 15.7507 7.44185 15.1203 7.02064C14.4899 6.59942 13.9986 6.00074 13.7085 5.30029C13.4183 4.59984 13.3424 3.82908 13.4903 3.08549C13.6382 2.34189 14.0033 1.65886 14.5394 1.12276C15.0755 0.586658 15.7586 0.221568 16.5022 0.0736581C17.2457 -0.0742519 18.0165 0.00166091 18.717 0.291797C19.4174 0.581933 20.0161 1.07326 20.4373 1.70365C20.8585 2.33404 21.0833 3.07517 21.0833 3.83333C21.0833 4.85 20.6795 5.82502 19.9606 6.54391C19.2417 7.2628 18.2667 7.66667 17.25 7.66667ZM17.25 1.91667C16.8709 1.91667 16.5003 2.02908 16.1852 2.23968C15.87 2.45029 15.6243 2.74963 15.4792 3.09986C15.3342 3.45008 15.2962 3.83546 15.3702 4.20726C15.4441 4.57905 15.6267 4.92057 15.8947 5.18862C16.1628 5.45667 16.5043 5.63922 16.8761 5.71317C17.2479 5.78713 17.6333 5.74917 17.9835 5.6041C18.3337 5.45904 18.633 5.21337 18.8436 4.89818C19.0543 4.58298 19.1667 4.21242 19.1667 3.83333C19.1667 3.325 18.9647 2.83749 18.6053 2.47805C18.2458 2.1186 17.7583 1.91667 17.25 1.91667ZM23 14.375C22.9985 12.8505 22.3922 11.3888 21.3142 10.3108C20.2362 9.23281 18.7745 8.62652 17.25 8.625C16.9958 8.625 16.7521 8.72597 16.5724 8.90569C16.3926 9.08541 16.2917 9.32917 16.2917 9.58333C16.2917 9.8375 16.3926 10.0813 16.5724 10.261C16.7521 10.4407 16.9958 10.5417 17.25 10.5417C18.2667 10.5417 19.2417 10.9455 19.9606 11.6644C20.6795 12.3833 21.0833 13.3583 21.0833 14.375C21.0833 14.6292 21.1843 14.8729 21.364 15.0526C21.5437 15.2324 21.7875 15.3333 22.0417 15.3333C22.2958 15.3333 22.5396 15.2324 22.7193 15.0526C22.899 14.8729 23 14.6292 23 14.375ZM5.75 7.66667C4.99184 7.66667 4.2507 7.44185 3.62031 7.02064C2.98993 6.59942 2.4986 6.00074 2.20846 5.30029C1.91833 4.59984 1.84241 3.82908 1.99032 3.08549C2.13823 2.34189 2.50332 1.65886 3.03942 1.12276C3.57553 0.586658 4.25856 0.221568 5.00215 0.0736581C5.74575 -0.0742519 6.5165 0.00166091 7.21695 0.291797C7.9174 0.581933 8.51609 1.07326 8.9373 1.70365C9.35851 2.33404 9.58333 3.07517 9.58333 3.83333C9.58333 4.85 9.17947 5.82502 8.46058 6.54391C7.74169 7.2628 6.76666 7.66667 5.75 7.66667ZM5.75 1.91667C5.37092 1.91667 5.00035 2.02908 4.68516 2.23968C4.36996 2.45029 4.1243 2.74963 3.97923 3.09986C3.83416 3.45008 3.79621 3.83546 3.87016 4.20726C3.94412 4.57905 4.12666 4.92057 4.39471 5.18862C4.66276 5.45667 5.00428 5.63922 5.37608 5.71317C5.74787 5.78713 6.13325 5.74917 6.48348 5.6041C6.8337 5.45904 7.13304 5.21337 7.34365 4.89818C7.55426 4.58298 7.66667 4.21242 7.66667 3.83333C7.66667 3.325 7.46473 2.83749 7.10529 2.47805C6.74584 2.1186 6.25833 1.91667 5.75 1.91667ZM1.91667 14.375C1.91667 13.3583 2.32053 12.3833 3.03942 11.6644C3.75831 10.9455 4.73334 10.5417 5.75 10.5417C6.00417 10.5417 6.24792 10.4407 6.42764 10.261C6.60737 10.0813 6.70833 9.8375 6.70833 9.58333C6.70833 9.32917 6.60737 9.08541 6.42764 8.90569C6.24792 8.72597 6.00417 8.625 5.75 8.625C4.22547 8.62652 2.76382 9.23281 1.68582 10.3108C0.607813 11.3888 0.00152225 12.8505 0 14.375C0 14.6292 0.100967 14.8729 0.280689 15.0526C0.460412 15.2324 0.704167 15.3333 0.958333 15.3333C1.2125 15.3333 1.45625 15.2324 1.63598 15.0526C1.8157 14.8729 1.91667 14.6292 1.91667 14.375Z"
                      fill="white"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                  >
                    <path
                      d="M11.5 15.3333C10.7418 15.3333 10.0007 15.1085 9.37031 14.6873C8.73993 14.2661 8.2486 13.6674 7.95846 12.967C7.66832 12.2665 7.59241 11.4957 7.74032 10.7522C7.88823 10.0086 8.25332 9.32553 8.78942 8.78942C9.32552 8.25332 10.0086 7.88823 10.7522 7.74032C11.4957 7.59241 12.2665 7.66833 12.967 7.95846C13.6674 8.2486 14.2661 8.73993 14.6873 9.37032C15.1085 10.0007 15.3333 10.7418 15.3333 11.5C15.3333 12.5167 14.9295 13.4917 14.2106 14.2106C13.4917 14.9295 12.5167 15.3333 11.5 15.3333ZM11.5 9.58333C11.1209 9.58333 10.7504 9.69575 10.4352 9.90635C10.12 10.117 9.8743 10.4163 9.72923 10.7665C9.58416 11.1167 9.54621 11.5021 9.62016 11.8739C9.69412 12.2457 9.87666 12.5872 10.1447 12.8553C10.4128 13.1233 10.7543 13.3059 11.1261 13.3798C11.4979 13.4538 11.8833 13.4158 12.2335 13.2708C12.5837 13.1257 12.883 12.88 13.0936 12.5648C13.3043 12.2496 13.4167 11.8791 13.4167 11.5C13.4167 10.9917 13.2147 10.5042 12.8553 10.1447C12.4958 9.78527 12.0083 9.58333 11.5 9.58333ZM17.25 22.0417C17.25 20.5167 16.6442 19.0541 15.5659 17.9758C14.4875 16.8975 13.025 16.2917 11.5 16.2917C9.975 16.2917 8.51247 16.8975 7.43414 17.9758C6.3558 19.0541 5.75 20.5167 5.75 22.0417C5.75 22.2958 5.85097 22.5396 6.03069 22.7193C6.21041 22.899 6.45417 23 6.70833 23C6.9625 23 7.20625 22.899 7.38598 22.7193C7.5657 22.5396 7.66667 22.2958 7.66667 22.0417C7.66667 21.025 8.07053 20.05 8.78942 19.3311C9.50831 18.6122 10.4833 18.2083 11.5 18.2083C12.5167 18.2083 13.4917 18.6122 14.2106 19.3311C14.9295 20.05 15.3333 21.025 15.3333 22.0417C15.3333 22.2958 15.4343 22.5396 15.614 22.7193C15.7937 22.899 16.0375 23 16.2917 23C16.5458 23 16.7896 22.899 16.9693 22.7193C17.149 22.5396 17.25 22.2958 17.25 22.0417ZM17.25 7.66667C16.4918 7.66667 15.7507 7.44185 15.1203 7.02064C14.4899 6.59942 13.9986 6.00074 13.7085 5.30029C13.4183 4.59984 13.3424 3.82908 13.4903 3.08549C13.6382 2.34189 14.0033 1.65886 14.5394 1.12276C15.0755 0.586658 15.7586 0.221568 16.5022 0.0736581C17.2457 -0.0742519 18.0165 0.00166091 18.717 0.291797C19.4174 0.581933 20.0161 1.07326 20.4373 1.70365C20.8585 2.33404 21.0833 3.07517 21.0833 3.83333C21.0833 4.85 20.6795 5.82502 19.9606 6.54391C19.2417 7.2628 18.2667 7.66667 17.25 7.66667ZM17.25 1.91667C16.8709 1.91667 16.5003 2.02908 16.1852 2.23968C15.87 2.45029 15.6243 2.74963 15.4792 3.09986C15.3342 3.45008 15.2962 3.83546 15.3702 4.20726C15.4441 4.57905 15.6267 4.92057 15.8947 5.18862C16.1628 5.45667 16.5043 5.63922 16.8761 5.71317C17.2479 5.78713 17.6333 5.74917 17.9835 5.6041C18.3337 5.45904 18.633 5.21337 18.8436 4.89818C19.0543 4.58298 19.1667 4.21242 19.1667 3.83333C19.1667 3.325 18.9647 2.83749 18.6053 2.47805C18.2458 2.1186 17.7583 1.91667 17.25 1.91667ZM23 14.375C22.9985 12.8505 22.3922 11.3888 21.3142 10.3108C20.2362 9.23281 18.7745 8.62652 17.25 8.625C16.9958 8.625 16.7521 8.72597 16.5724 8.90569C16.3926 9.08541 16.2917 9.32917 16.2917 9.58333C16.2917 9.8375 16.3926 10.0813 16.5724 10.261C16.7521 10.4407 16.9958 10.5417 17.25 10.5417C18.2667 10.5417 19.2417 10.9455 19.9606 11.6644C20.6795 12.3833 21.0833 13.3583 21.0833 14.375C21.0833 14.6292 21.1843 14.8729 21.364 15.0526C21.5437 15.2324 21.7875 15.3333 22.0417 15.3333C22.2958 15.3333 22.5396 15.2324 22.7193 15.0526C22.899 14.8729 23 14.6292 23 14.375ZM5.75 7.66667C4.99184 7.66667 4.2507 7.44185 3.62031 7.02064C2.98993 6.59942 2.4986 6.00074 2.20846 5.30029C1.91833 4.59984 1.84241 3.82908 1.99032 3.08549C2.13823 2.34189 2.50332 1.65886 3.03942 1.12276C3.57553 0.586658 4.25856 0.221568 5.00215 0.0736581C5.74575 -0.0742519 6.5165 0.00166091 7.21695 0.291797C7.9174 0.581933 8.51609 1.07326 8.9373 1.70365C9.35851 2.33404 9.58333 3.07517 9.58333 3.83333C9.58333 4.85 9.17947 5.82502 8.46058 6.54391C7.74169 7.2628 6.76666 7.66667 5.75 7.66667ZM5.75 1.91667C5.37092 1.91667 5.00035 2.02908 4.68516 2.23968C4.36996 2.45029 4.1243 2.74963 3.97923 3.09986C3.83416 3.45008 3.79621 3.83546 3.87016 4.20726C3.94412 4.57905 4.12666 4.92057 4.39471 5.18862C4.66276 5.45667 5.00428 5.63922 5.37608 5.71317C5.74787 5.78713 6.13325 5.74917 6.48348 5.6041C6.8337 5.45904 7.13304 5.21337 7.34365 4.89818C7.55426 4.58298 7.66667 4.21242 7.66667 3.83333C7.66667 3.325 7.46473 2.83749 7.10529 2.47805C6.74584 2.1186 6.25833 1.91667 5.75 1.91667ZM1.91667 14.375C1.91667 13.3583 2.32053 12.3833 3.03942 11.6644C3.75831 10.9455 4.73334 10.5417 5.75 10.5417C6.00417 10.5417 6.24792 10.4407 6.42764 10.261C6.60737 10.0813 6.70833 9.8375 6.70833 9.58333C6.70833 9.32917 6.60737 9.08541 6.42764 8.90569C6.24792 8.72597 6.00417 8.625 5.75 8.625C4.22547 8.62652 2.76382 9.23281 1.68582 10.3108C0.607813 11.3888 0.00152225 12.8505 0 14.375C0 14.6292 0.100967 14.8729 0.280689 15.0526C0.460412 15.2324 0.704167 15.3333 0.958333 15.3333C1.2125 15.3333 1.45625 15.2324 1.63598 15.0526C1.8157 14.8729 1.91667 14.6292 1.91667 14.375Z"
                      fill="#787486"
                    />
                  </svg>
                )}
              </div>

              {page == "Access" ? (
                <p
                  style={{ transform: "translateY(2px)" }}
                  className="textCheckedSidebar"
                >
                  Gerenciar acessos
                </p>
              ) : (
                <p
                  style={{ transform: "translateY(2px)" }}
                  className="textNotCheckedSidebar"
                >
                  Gerenciar acessos
                </p>
              )}
            </div>
          </div>

          <div
            onClick={() => redirectToLoginPage()}
            style={containerItemNotChecked}
          >
            <div style={{ ...image, transform: "translateY(-5px)" }}>
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.10243 16.5725H3.94576C3.52716 16.5725 3.12571 16.4063 2.82971 16.1103C2.53372 15.8143 2.36743 15.4128 2.36743 14.9942V3.94589C2.36743 3.52729 2.53372 3.12583 2.82971 2.82984C3.12571 2.53384 3.52716 2.36755 3.94576 2.36755H7.10243"
                  stroke="#787486"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12.6267 13.4158L16.5725 9.47L12.6267 5.52417"
                  stroke="#787486"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16.5725 9.46997H7.10254"
                  stroke="#787486"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <p className="textNotCheckedSidebar">Sair</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Sidebar;
